module.exports = __webpack_public_path__ + "img/qrcode_navigatenetwork.705b1295.jpg";